import {Component, Inject} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from '../../../../services/app.service';

@Component({
    selector: 'save-filters-dialog',
    templateUrl: 'save-filters-dialog.component.html',
    styleUrls: ["./save-filters-dialog.component.scss"]
})
export class SaveFiltersDialog {
    label:string = "";
    constructor(
        public dialogRef: MatDialogRef<SaveFiltersDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private appService: AppService
    ) { }
}